import { isTablet, isBrowser } from 'react-device-detect'

/**
 * Hook to determine if a view is in mobile mode
 */
export const useIsMobile = (forceMobile) => {
	var isDesktop = isBrowser || isTablet
    return forceMobile === true ? true : !isDesktop
}
